import React from 'react'
import cx from 'classnames'
import IconSVG from 'svg-inline-react'

import boltIconSrc from '!svg-inline?removeTags=true!images/svg/bolt.svg'
import minusIconSrc from '!svg-inline?removeTags=true!images/svg/minus.svg'

import './style.styl'

const CQLBar = ({ selectedScore, handleSelectCql }) => {
  return (
    <div className="cql-bar-container">
      <div className="cql-bar">
        <div
          is
          onClick={handleSelectCql.bind(null, -1)}
          class={cx('cql-bar-option', { selected: selectedScore === -1 })}
          flow="up"
          tooltip="Unqualified"
        >
          <IconSVG className="cql-bar-minus-icon" src={minusIconSrc} />
        </div>
        <div
          is
          onClick={handleSelectCql.bind(null, 1)}
          class={cx('cql-bar-option', { selected: selectedScore === 1 })}
          flow="up"
          tooltip="Good CQL"
        >
          <IconSVG className="cql-bar-bolt-icon" src={boltIconSrc} />
        </div>
        <div
          is
          onClick={handleSelectCql.bind(null, 2)}
          class={cx('cql-bar-option', { selected: selectedScore === 2 })}
          flow="up"
          tooltip="Better CQL"
        >
          <IconSVG className="cql-bar-bolt-icon" src={boltIconSrc} />
          <IconSVG className="cql-bar-bolt-icon" src={boltIconSrc} />
        </div>
        <div
          is
          onClick={handleSelectCql.bind(null, 3)}
          class={cx('cql-bar-option', { selected: selectedScore === 3 })}
          flow="up"
          tooltip="Best CQL"
        >
          <IconSVG className="cql-bar-bolt-icon" src={boltIconSrc} />
          <IconSVG className="cql-bar-bolt-icon" src={boltIconSrc} />
          <IconSVG className="cql-bar-bolt-icon" src={boltIconSrc} />
        </div>
      </div>
    </div>
  )
}
export default CQLBar



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ActionConfigCQL/component.js